import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Typography, Grid, CircularProgress, Button, Box } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { QRCodeSVG } from 'qrcode.react';

import placeholderItem from 'styles/assets/placeholder/placeholder.gif';
import consumedVoucher from 'styles/assets/Wallet/consumedVoucher.png';
import consumedVoucher_ES from 'styles/assets/Wallet/consumedVoucher_ES.png';
import AppBarPromotion from 'js/containers/ApplessPromotions/AppBar';
import FooterPromotion from 'js/containers/ApplessPromotions/Footer';
import EstablishmentInfo from 'js/containers/ApplessPromotions/EstablishmentInfo';
import findWalletVoucher from 'js/library/utils/API/findWalletVoucher';
import { downloadImage } from 'js/library/services/StorageManager.js';
import {
  convertToDateDefault,
  startMatomo,
  trackEventMatomoVisit,
  trackEventMatomoElementId,
} from 'js/library/utils/helpers';
import { getStoreItem } from 'js/library/utils/API/getStoreItem';
import cfac22 from 'js/library/utils/cfac22';

export default function ApplessVoucher() {
  const applessTheme = createTheme({
    palette: {
      primary: {
        main: '#fff',
      },
      secondary: {
        main: '#324996',
      },
    },
  });

  //buscando variáveis da URL
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const voucherId = urlParams.get('id');

  const { t } = useTranslation();
  const verifyLanguage = localStorage.getItem('i18nextLng');

  const [voucherInfo, setVoucherInfo] = useState(voucherId === null ? false : null);
  const [thumbnail, setThumbnail] = useState(placeholderItem);
  const [establishmentInfo, setEstablishmentInfo] = useState(null);

  useEffect(() => {
    startMatomo();

    trackEventMatomoVisit('Cupom de link externo');

    document.title = 'Resgate de link externo';

    try {
      if (voucherId !== null) {
        findWalletVoucher(voucherId)
          .then((result) => {
            if (result.success) {
              downloadImage('voucher', result.voucher.thumbnail)
                .then((result) => {
                  setThumbnail(result);
                })
                .catch((error) => {
                  return error;
                });

              setVoucherInfo(result.voucher);

              getStoreItem(cfac22('uIdLandingPages'), result.voucher.establishmentId).then(
                (establishment) => {
                  setEstablishmentInfo(establishment.placesItem);
                }
              );
            } else {
              setVoucherInfo(false);
            }
          })
          .catch(() => {
            setVoucherInfo(false);
          });
      }
    } catch (error) {
      setVoucherInfo(false);
    }
  }, [voucherId]);

  return (
    <ThemeProvider theme={applessTheme}>
      {voucherInfo === null ? (
        <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justifyContent="center"
          align="center"
          className="background-login"
          onLoad={() =>
            trackEventMatomoElementId('Cupom de link externo', 'visualizar', 'loading', '')
          }
        >
          <Grid size={{ md: 4, sm: 6, xs: 10 }}></Grid>

          <Grid size={{ md: 4, sm: 6, xs: 10 }}>
            <CircularProgress color="secondary" />
            <Typography variant="h6">{t('general.wait_a_moment')}</Typography>
          </Grid>

          <Grid size={{ md: 4, sm: 6, xs: 10 }}></Grid>
        </Grid>
      ) : voucherInfo === false ? (
        <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justifyContent="center"
          align="center"
          className="background-login"
          onLoad={() =>
            trackEventMatomoElementId('Cupom de link externo', 'visualizar', 'erro', '')
          }
        >
          <Grid size={{ md: 4, sm: 6, xs: 10 }}></Grid>

          <Grid size={{ md: 4, sm: 6, xs: 10 }}>
            <Typography variant="h6">{t('errors.try_later')}</Typography>
            <a href={cfac22('homepage')} style={{ textDecoration: 'none' }}>
              <Button variant="contained" color="secondary" style={{ textTransform: 'none' }}>
                {t('general.go_back_triibo')}
              </Button>
            </a>
          </Grid>

          <Grid size={{ md: 4, sm: 6, xs: 10 }}></Grid>
        </Grid>
      ) : (
        <>
          <Box sx={{ display: { lg: 'block', md: 'block', sm: 'block', xs: 'none' } }}>
            <AppBarPromotion
              onClick={() =>
                trackEventMatomoElementId('Cupom de link externo', 'tocar', 'menu', '')
              }
              establishmentName={voucherInfo.establishmentName}
            />
          </Box>

          <div
            style={{
              backgroundColor: '#324996',
              width: '100%',
              padding: '20px 0px',
            }}
          >
            <div style={{ backgroundColor: '#324996', width: '100%' }}>
              <div className="card-promotion">
                <Grid container spacing={0} style={{ padding: '30px' }}>
                  <Box sx={{ display: { lg: 'none', md: 'none', sm: 'none', xs: 'block' } }}>
                    <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
                      <img src={thumbnail} width="100%" alt="imagem da promoção" />
                    </Grid>
                  </Box>

                  <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
                    {voucherInfo.state !== 'finished' && voucherInfo.status !== 'consumido' ? (
                      <>
                        <Typography variant="h5" color="secondary" style={{ fontWeight: 'bolder' }}>
                          {t('general.consume_code')}
                        </Typography>

                        {voucherInfo.state === 'finished' || voucherInfo.status === 'consumido' ? (
                          verifyLanguage === 'pt-BR' ? (
                            consumedVoucher
                          ) : (
                            consumedVoucher_ES
                          )
                        ) : (
                          <div style={{ margin: '20px 0px' }}>
                            <QRCodeSVG
                              onClick={() =>
                                trackEventMatomoElementId(
                                  'Cupom de link externo',
                                  'tocar',
                                  'qrCode',
                                  voucherInfo.id
                                )
                              }
                              id="QRCode"
                              value={voucherInfo.id}
                              size={140}
                              bgColor={'#ffffff'}
                              fgColor={'#000000'}
                              level={'M'}
                            />
                          </div>
                        )}
                      </>
                    ) : (
                      <>
                        <Typography variant="h5" color="secondary" style={{ fontWeight: 'bolder' }}>
                          {t('general.coupon_used_in')}{' '}
                          {convertToDateDefault(voucherInfo.consumedDate)}
                        </Typography>

                        <div style={{ margin: '20px 0px' }}>
                          <img
                            width="70%"
                            src={verifyLanguage === 'pt-BR' ? consumedVoucher : consumedVoucher_ES}
                            alt="cupom consumido"
                          />
                        </div>
                      </>
                    )}

                    <Typography
                      onClick={() =>
                        trackEventMatomoElementId(
                          'Cupom de link externo',
                          'tocar',
                          'coupon-code',
                          voucherInfo.id
                        )
                      }
                      variant="h2"
                      color="secondary"
                      style={{ fontWeight: 'bolder' }}
                    >
                      <u>{voucherInfo.id}</u>
                    </Typography>

                    <Typography
                      variant="subtitle2"
                      color="secondary"
                      style={{ fontWeight: 'bolder' }}
                    >
                      {t('general.to_redeem_enter_the_code_or_present_qr_code')}
                    </Typography>
                  </Grid>
                </Grid>
              </div>
            </div>
          </div>

          {establishmentInfo !== null && (
            <EstablishmentInfo
              props={{
                establishmentInfo: establishmentInfo,
                storeInfo: voucherInfo,
                thumbnail: thumbnail,
              }}
            />
          )}

          <FooterPromotion />
        </>
      )}
    </ThemeProvider>
  );
}
